/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

function MediaAcceptProfileMemberController(this: JS5Object, _: JS5Object, uiGridConstants: JS5Object, $route: JS5Object,
                                            $location: JS5Object, PackageAcceptTemplatesService: JS5Object,
                                            ModalService: JS5Object, BreadcrumbService: JS5Object,
                                            SidebarService: JS5Object, $timeout: JS5Object) {



    this.$onInit = () => {
        setGridData();
    };

    this.$onChanges = () => {
        setGridData();
    };

    const setGridData = ()=>{
        this.gridOptions.data = _.filter(_.get(this.ngModel, this.modelProp), (mediaAcceptProfile: JS5Object) => {
            return mediaAcceptProfile.type === this.mediaAcceptProfileType
        });
    };

    this.addMediaProfileHandler = () => {
        ModalService.showMediaAcceptProfilesModal(selectedMediaAcceptProfilesHandler, this.mediaAcceptProfileType);
    };

    this.removeMediaAcceptProfile = () => {
        const selectedMediaAcceptProfiles = this.gridApi.selection.getSelectedRows();
        ModalService.showMessageModal({
            messageText: 'Are you sure you want to remove the selected mediaAcceptProfile(s)?',
            pullCancelLeft: true,
            title: 'Remove Media Accept Profile(s)',
            windowClass: 'confirm-modal-sm',
            showOK: true
        }, () => {
            _.set(this.ngModel, this.modelProp,_.differenceBy(_.get(this.ngModel, this.modelProp), selectedMediaAcceptProfiles, 'id'));
            setGridData();
            this.editorForm.$setDirty();
        });
    };
    const selectedMediaAcceptProfilesHandler = (selectedMediaAcceptProfiles: JS5Object) => {
        const numberOfMediaAcceptProfilesBeforeAdd = _.size(_.get(this.ngModel, this.modelProp));
        _.set(this.ngModel, this.modelProp, _.unionBy(_.get(this.ngModel, this.modelProp), selectedMediaAcceptProfiles, 'id'));
        if (_.size(_.get(this.ngModel, this.modelProp)) > numberOfMediaAcceptProfilesBeforeAdd) {
            this.editorForm.$setDirty();
            setGridData();
        }
    };

    this.gridOptions = {
        rowSelection: true,
        enableRowHeaderSelection: false,
        enableSelectAll: true,
        enableColumnResizing: true,
        enablePaginationControls: false,
        enableSorting: true,
        enableColumnMenus: false,
        enableFullRowSelection: true,
        enableHorizontalScrollbar: uiGridConstants.ALWAYS,
        enableVerticalScrollbar: uiGridConstants.ALWAYS,
        rowHeight: 26,
        multiSelect: true,
        columnDefs: [
            {
                field: 'name',
                displayName: 'Name',
                sort: {
                    direction: 'asc',
                },
                cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
            },
            {
                field: 'type',
                displayName: 'Type',
                cellTemplate: 'system/templates/mediaAcceptProfiles/searchView/renderers/accept-profile-tooltip-template.html'
            }
        ],
        onRegisterApi: (gridApi: JS5Object): void => {
            this.gridApi = gridApi;
        },
        rowTemplate: 'components/visual/grid/searchview-component-row-template.html',
        data: []
    };
}


angular.module('prism-ui.packageAcceptTemplate').component('mediaAcceptProfileMember', {
    templateUrl: 'system/templates/packageAcceptTemplates/editView/mediaAcceptProfileMembers/media-accept-profile-member-template.html',
    controller: MediaAcceptProfileMemberController,
    bindings: {
        mediaAcceptProfileType: '<',
        ngModel: '<',
        modelProp: '<',
    }
});
